var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2986 0C13.4416 1.30129 12.9266 2.58361 12.1739 3.52617C11.3885 4.45406 10.132 5.16378 8.90825 5.07237C8.74807 3.82023 9.36813 2.48875 10.0623 1.67642C10.8468 0.75456 12.2092 0.0482918 13.2986 0ZM17.3048 7.50675C17.1682 7.58836 14.9049 8.94102 14.9297 11.6996C14.9581 15.0309 17.8397 16.1321 17.875 16.1442C17.8578 16.2218 17.4237 17.7335 16.3429 19.2685C15.4404 20.6198 14.4948 21.9409 12.9929 21.9651C12.2789 21.9815 11.7967 21.7759 11.2943 21.5617C10.7703 21.3382 10.2242 21.1053 9.36986 21.1053C8.46413 21.1053 7.8938 21.3457 7.34374 21.5775C6.86818 21.7779 6.40777 21.9719 5.75888 21.9987C4.32844 22.0513 3.23558 20.556 2.30033 19.2168C0.430679 16.4822 -1.02474 11.5108 0.926726 8.12775C1.87232 6.46858 3.59642 5.40012 5.43938 5.37166C6.25093 5.35505 7.0293 5.66823 7.71165 5.94278C8.23345 6.15273 8.6991 6.34009 9.0805 6.34009C9.41549 6.34009 9.86807 6.16022 10.3956 5.95058C11.2268 5.6202 12.2442 5.21589 13.2805 5.32509C13.9893 5.34579 16.0062 5.60536 17.3075 7.50513L17.3048 7.50675Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.91d928b0570a8fc0f465fcbab2674db7.svg";
export { ForwardRef as ReactComponent };